<script lang="ts">
    import { _ } from "svelte-i18n";
    import { appManager } from "../../AppManager";
    import { ModalHook } from "../../shared/modals/ModalHook";
    import type { ScenarioData } from "../../api/projects/data/scenarios/ScenarioData";

    let hook = new ModalHook<ScenarioData, boolean>();
    appManager.ModalHooks.ScenarioDeleteConfirmModal = hook;
    let open: boolean = false;
    let data: ScenarioData;

    // hook events.
    hook.on("open", () => {
        open = true;

        data = hook.getData();
    });
    hook.on("close", () => {
        open = false;
    });

    const ok = () => {
        hook.close(true);
    };

    const close = () => {
        hook.close(false);
    };
</script>

{#if open}
    <div
        class="modal show" style="display: block;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="Label"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body p-6">
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close" 
                        on:click={close}/>

                    <h4 class="font-weight-bold text-center mb-3">
                        {$_("impact.scenario.delete.areYouSure")}
                    </h4>

                    {#if typeof data !== "undefined"}
                        <p
                            class="font-size-lg text-center mb-6 mb-md-8">
                            {data.name}
                        </p>

                        <p
                            class="font-size-lg text-center text-muted mb-6 mb-md-8">
                            {@html data.description}
                        </p>
                    {/if}

                    <div class="row">
                        <div class="col-6">
                            <div class="d-grid gap-2">
                                <button
                                    class="btn btn-block btn-primary-desat-soft mt-3 lift"
                                    on:click={ok}>
                                    {$_("impact.scenario.delete.delete")}
                                </button>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="d-grid gap-2">
                                <button
                                    class="btn btn-block btn-secondary-desat-soft mt-3 lift"
                                    on:click={close}>
                                    {$_("impact.scenario.delete.cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
